export const WHEN_TO_USE = `Start an interactive, in-app guided tour that walks the user
through a feature step by step. Pick the tour whose 'whenToUse' best matches the
user's request from the list in the context.

Call it ONLY when the user asks to be shown, guided, or walked through one of the
listed features, or explicitly asks to start a tour. Do not invent a tour that is
not in the list.`;

export const START_PRODUCT_TOUR_CONTEXT_DESCRIPTION = `'availableTours' — the tours you can start. Each entry
has an 'id' (pass it back as 'tourId'), a 'name', a 'description' of what the tour
covers, and a 'whenToUse' hint for matching the user's request.`;
